import type { MonsterDef } from '../../sim/registry';
import { monsterStats } from '../balance';
import { circle, cone, rect } from '../classes/kit';
import { mLunge, mMelee, mShoot, mSlam } from './kit';

/** Emberwild Vale (levels 1–12): forest beasts, grublings and bandits. */
export const EMBERWILD_MONSTERS: MonsterDef[] = [
  {
    id: 'vale_wolf', name: 'Vale Wolf', grade: 'normal', model: 'mob_wolf', scale: 1, radius: 0.6, creature: 'Beast',
    stats: (l) => monsterStats(l, 'normal', { speed: 1.15 }),
    skills: [
      mMelee('wolf_bite', 'Bite', { shape: cone(2.2, 70), coef: 1.1, windup: 0.35, cd: 1.8 }),
      mLunge('wolf_lunge', 'Pounce', { distance: 4, coef: 1.5, windup: 0.55, cd: 7, range: [2.5, 5.5] }),
    ],
    brain: 'melee', aggroRange: 9, leash: 22, xp: 18, loot: 'vale_beast',
  },
  {
    id: 'thornback_boar', name: 'Thornback Boar', grade: 'normal', model: 'mob_boar', scale: 1, radius: 0.7, creature: 'Beast',
    stats: (l) => monsterStats(l, 'normal', { hp: 1.3 }),
    skills: [
      mMelee('boar_gore', 'Gore', { shape: cone(2.4, 60), coef: 1.2, windup: 0.4, cd: 2.2, reaction: { kind: 'knockback', power: 1.5 } }),
      mLunge('boar_charge', 'Thorn Charge', { distance: 7, coef: 1.8, windup: 0.7, cd: 8, range: [3, 8], width: 1.8, reaction: { kind: 'knockdown', duration: 1, power: 2 } }),
    ],
    brain: 'melee', aggroRange: 7, leash: 20, xp: 22, loot: 'vale_beast',
  },
  {
    id: 'grubling', name: 'Grubling', grade: 'minion', model: 'mob_grubling', scale: 1, radius: 0.4, creature: 'Goblinoid',
    stats: (l) => monsterStats(l, 'minion', { speed: 1.1 }),
    skills: [mMelee('grub_stab', 'Stab', { shape: cone(1.8, 60), coef: 0.9, windup: 0.3, cd: 1.5 })],
    brain: 'melee', aggroRange: 10, leash: 22, xp: 8, loot: 'grubling',
  },
  {
    id: 'grubling_brute', name: 'Grubling Brute', grade: 'elite', model: 'mob_grubling', scale: 1.7, radius: 0.8, tint: 0xa06040, creature: 'Goblinoid',
    stats: (l) => monsterStats(l, 'elite'),
    skills: [
      mMelee('brute_club', 'Club Smash', { shape: cone(3, 90), coef: 1.5, windup: 0.6, cd: 2.6, reaction: { kind: 'knockback', power: 2 } }),
      mSlam('brute_quake', 'Ground Pound', { shape: circle(4), coef: 2.2, delay: 1.0, cd: 9, range: [0, 3.5], telegraph: 'red' }),
    ],
    brain: 'melee', aggroRange: 10, leash: 22, xp: 60, loot: 'elite',
  },
  {
    id: 'vale_bandit', name: 'Vale Bandit', grade: 'normal', model: 'mob_bandit', scale: 1, radius: 0.45, creature: 'Human',
    stats: (l) => monsterStats(l, 'normal'),
    skills: [
      mMelee('bandit_chop', 'Axe Chop', { shape: cone(2.4, 80), coef: 1.2, windup: 0.45, cd: 2 }),
      mSlam('bandit_whirl', 'Whirlwind', { shape: circle(3), coef: 1.6, delay: 0.7, cd: 8, range: [0, 2.5] }),
    ],
    brain: 'melee', aggroRange: 9, leash: 22, xp: 20, loot: 'bandit',
  },
  {
    id: 'bandit_archer', name: 'Bandit Archer', grade: 'normal', model: 'mob_bandit', scale: 0.95, radius: 0.45, tint: 0x6a7a4a, creature: 'Human',
    stats: (l) => monsterStats(l, 'normal', { hp: 0.8 }),
    skills: [mShoot('archer_shot', 'Arrow', { coef: 1.1, speed: 20, range: 15, windup: 0.6, cd: 2.2, anim: 'Attack' })],
    brain: 'ranged', aggroRange: 13, leash: 24, xp: 20, loot: 'bandit',
  },
  {
    id: 'elder_thornback', name: 'Elder Thornback', grade: 'named', model: 'mob_boar', scale: 2.2, radius: 1.5, tint: 0x7a4a2a, creature: 'Beast',
    title: 'Field Boss', stagger: 400, hpBars: 12,
    stats: (l) => monsterStats(l, 'named', { hp: 3 }),
    skills: [
      mMelee('elder_gore', 'Tusk Sweep', { shape: cone(4.5, 120), coef: 1.6, windup: 0.6, cd: 3, range: [0, 4], reaction: { kind: 'knockback', power: 3 } }),
      mLunge('elder_charge', 'Stampede', { distance: 12, coef: 2.4, windup: 0.9, cd: 10, range: [4, 14], width: 3, reaction: { kind: 'knockdown', duration: 1.4, power: 3 } }),
      mSlam('elder_quake', 'Thorn Quake', { shape: circle(7), coef: 2.8, delay: 1.3, cd: 14, range: [0, 6], telegraph: 'red' }),
      mSlam('elder_thorns', 'Thorn Eruption', { shape: rect(14, 3), coef: 2.2, delay: 1.0, cd: 11, range: [0, 12], telegraph: 'red' }),
    ],
    brain: 'melee', aggroRange: 12, leash: 30, xp: 400, loot: 'field_boss',
  },
];
